export default __webpack_public_path__ + "static/media/frogcast.9eac2d3c.gif";